import { render } from "./ContactCard.vue?vue&type=template&id=833160c6&scoped=true"
import script from "./ContactCard.vue?vue&type=script&lang=js"
export * from "./ContactCard.vue?vue&type=script&lang=js"

import "./ContactCard.vue?vue&type=style&index=0&id=833160c6&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-833160c6"]])

export default __exports__